module.exports = __webpack_public_path__ + "img/banner1.25e7b00b.png";